import { AxiosError } from 'axios';

export function isAxiosError(e: Error): e is AxiosError {
  const x = e as any;
  return x.config != null;
}


// WEBPACK FOOTER //
// ./src/shared/isAxiosError.ts